import { render, staticRenderFns } from "./SchoolFinancing.vue?vue&type=template&id=a6fa4cec&scoped=true&"
import script from "./SchoolFinancing.vue?vue&type=script&lang=js&"
export * from "./SchoolFinancing.vue?vue&type=script&lang=js&"
import style0 from "./SchoolFinancing.vue?vue&type=style&index=0&id=a6fa4cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa4cec",
  null
  
)

export default component.exports